import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Default } from "../../components/Default/Default";
import { useOtbViewModel } from "../../viewModel/useOtbVewModel";
import { OtbDetalhadoSection } from "./components/OtbDetalhado/OtbDetalhadoSection";
import { SidebarForOtb } from "./OtbPlanningScreen"
import { LoadingContent } from "../../components/SharedComponents/sharedComponents.index";

import { LOADING_CONTENT_TYPE } from "../../components/SharedComponents/LoadingContent/loading.content.constants";
import { OTB_VIEWS } from "../../components/components.constants";
import { ROUTES_APPLICATION_PATH } from "../../routes.constants";
import { SYSTEM_COLORS } from "../../components/system.colors";


const PURCHASE_PLAN_PATH = ROUTES_APPLICATION_PATH.PRODUCTS.COMPONENT_URL[4];
const GENERAL_CYCLE_ID = 1;

export function OtbDetalhado() {
  const navigate = useNavigate();

  const [selectedCycleId, setSelectedCycleId] = useState(1);
  const [activeView, setActiveView] = useState(OTB_VIEWS.DETAILED_OTB);
  const [sidebarWidth, setSidebarWidth] = useState(220);

  const vm_otb = useOtbViewModel({
    shouldFetchOtbCycles: true,
    shouldFetchOtbConsolidated: Boolean(selectedCycleId),
    shouldFetchOtbDetail: Boolean(selectedCycleId),
    cycleId: selectedCycleId,
  });

  if (!selectedCycleId || vm_otb?.uiState?.isLoadingOtbData || vm_otb?.uiState?.isLoadingOtbCycles) {
    return <LoadingContent label={"Carregando dados..."} type={LOADING_CONTENT_TYPE.API_PAGE_DATA} />;
  }  

  const selectedOtb = vm_otb?.ctx?.otbCycles?.find((otb) => otb.cycleId === selectedCycleId);

  const openPurchasePlan = ({ category, monthKey, onlyWithPurchase }) => {
    navigate(PURCHASE_PLAN_PATH, {
      state: {
        initialFilter: {
          otbName: selectedCycleId === GENERAL_CYCLE_ID ? undefined : selectedOtb?.otbName,
          category,
          monthKey,
          onlyWithPurchase,
        },
      },
    });
  };

  return (
    <Default>
      <div style={{
        display: "flex",
        height: "100%",
        backgroundColor: SYSTEM_COLORS.WHITE.ALABASTER,
        fontFamily: "'Segoe UI', system-ui, -apple-system, sans-serif",
        overflow: "hidden",
        marginLeft: "calc(72px - 5rem)",
        marginTop: "-0.2rem",
      }}>
        <SidebarForOtb
          actions={{
            setActiveView: setActiveView,
            selectOtb: (cycleId) => {
              setSelectedCycleId(cycleId);
              setActiveView(OTB_VIEWS.DETAILED_OTB);
            },
            toggleOtbSidebar: vm_otb?.actions?.toggleOtbSidebar,
            onWidthChange: setSidebarWidth
          }}
          ctx={{
            otbs: vm_otb?.ctx?.otbCycles,
            selectedOtbId: selectedCycleId,
          }}
          uiState={{
            activeView: activeView,
            otbSidebarOpen: vm_otb?.uiState?.otbSidebarOpen,
            displayTabs: {
              performanceTab: false
            }
          }}
        />

        <div style={{ flex: 1, minWidth: 0, marginLeft: sidebarWidth, padding: "24px 32px", overflow: "auto" }}>
          <OtbDetalhadoSection
            actions={{
              saveOtbVersion: vm_otb?.actions?.saveOtbVersion,
              setSelectedCategory: vm_otb?.actions?.setSelectedCategory,
              setSelectedCategoryName: vm_otb?.actions?.setSelectedCategoryName,
              setSelectedCycleId: setSelectedCycleId,
              openPurchasePlan: openPurchasePlan
            }}            
            ctx={{
              otbByValueData: vm_otb?.ctx?.openToBuyByValueData,
              openToBuyByUnitsData: vm_otb?.ctx?.openToBuyByUnitsData,
              categoryHierarchy: vm_otb?.ctx?.categoryHierarchy,
              openToBuyAchievedData: vm_otb?.ctx?.openToBuyAchievedData,
              plannedOtbConsolidated: vm_otb?.ctx?.plannedOtbConsolidated,
              otbDetailByLevel: vm_otb?.ctx?.otbDetailByLevel,
              selectedCategory: vm_otb?.ctx?.selectedCategory,
              allOtbCycles: vm_otb?.ctx?.otbCycles,
              selectedOtb: selectedOtb,
              productHierarchy: vm_otb?.ctx?.productHierarchy,
              categoryToGroupMap: vm_otb?.ctx?.categoryToGroupMap,
            }}
            uiState={{
              isLoadingOtbDetail: vm_otb?.uiState?.isLoadingOtbDetail
            }}
          />
        </div>
      </div>
    </Default>
  );
}